// extracted by mini-css-extract-plugin
export default {"nav":"sidebar_nav__V188o","sidebar":"sidebar_sidebar__naBLg","item_wrapper":"sidebar_item_wrapper__FMn-2"};